/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type DeprecatedProjectGroupIndicator_projectGroup = {
    readonly name: string | null;
    readonly companyProjectGroupId: number | null;
    readonly color: string | null;
    readonly " $refType": "DeprecatedProjectGroupIndicator_projectGroup";
};
export type DeprecatedProjectGroupIndicator_projectGroup$data = DeprecatedProjectGroupIndicator_projectGroup;
export type DeprecatedProjectGroupIndicator_projectGroup$key = {
    readonly " $data"?: DeprecatedProjectGroupIndicator_projectGroup$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"DeprecatedProjectGroupIndicator_projectGroup">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeprecatedProjectGroupIndicator_projectGroup",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyProjectGroupId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    }
  ],
  "type": "ProjectGroupType"
};
(node as any).hash = '8f42b0ec58e4624928b71d3c631bf9d2';
export default node;
